import "./CreateIdea.css";
import { AnyAction } from "redux";
import IdeaForm from "./IdeaForm";
import history from "routes/history";
import IdeaFormV3 from "./IdeaFormV3";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import reactNewApp from "utils/reactNewApp";
import IdeaFormSkeleton from "./IdeaFormSkeleton";
import React, { useState, useEffect } from "react";
import { IAppState } from "../../../redux/store/Store";
import Resource from "../../../components/Resources/Resource";
import { getAllUsers } from "../../../redux/actions/UsersAction";
import { IIdeaDetails, IIdeasSimilares } from "redux/types/ideas";
import { IApplication } from "../../../redux/reducers/tenantReducer";
import { ICultureState } from "../../../redux/reducers/cultureReducer";
import { IUsers, IUsersState } from "../../../redux/reducers/usersReducers";
import { IChallengeState } from "redux/reducers/challenges/challengeReducer";
import PopUpConfirmation from "components/PopUpConfirmation/PopUpConfirmation";
import {
  IChallengeList,
  IChallengeListItem,
  IIdeaForm,
  IIdeaFormV3,
} from "redux/types/challenges";
import {
  getAllIdeaDetails,
  putIdeaUpdate,
  IdeaPutAction,
  IIdeasDetailGetAllAction,
  postIdeasSimilares,
  IIdeasSimilaresGetAllSucceededAction,
} from "redux/actions/ideas/IdeaAction";
import {
  getAllChallengeList,
  getIdeasForm,
  getIdeasFormV3,
  IChallengeGetAllListAction,
  IChallengeGetIdeaFormAction,
} from "../../../redux/actions/ChallengeActions";

interface IDispatchProps {
  getAllUsers: (options: object) => Promise<IUsersState>;
  getIdeasFormV3: (params: object) => Promise<IChallengeState>;
  getIdeasForm: (options: object) => Promise<IChallengeGetIdeaFormAction>;
  putIdeaUpdate: (params: object, culture: ICultureState) => Promise<IdeaPutAction>;
  getAllIdeaDetails: (params: object) => Promise<IIdeasDetailGetAllAction>;
  getAllChallengeList: (options: object) => Promise<IChallengeGetAllListAction>;
  postIdeasSimilares: (
    options: object,
    culture: ICultureState
  ) => Promise<IIdeasSimilaresGetAllSucceededAction>;
}

interface IProps {
  workspaceId: string;
  ideaFormV3: IIdeaFormV3[];
  ideasForm: IIdeaForm;
  application: IApplication;
  culture: ICultureState;
  userList: IUsers[];
  challengeList: IChallengeList;
  ideaChallenge: IChallengeListItem;
  ideaId: string;
  ideaDetail?: IIdeaDetails;
  applicationId: any;
}

function EditIdea(props: IProps & IDispatchProps) {
  const {
    workspaceId,
    getIdeasFormV3,
    getIdeasForm,
    getAllIdeaDetails,
    getAllUsers,
    postIdeasSimilares,
    getAllChallengeList,
    applicationId,
    ideaFormV3,
    ideasForm,
    ideaDetail,
    culture
  } = props;
  const [load, setLoad] = useState(true);
  const [challenge, setChallenge] = useState<IChallengeListItem>(
    props.ideaChallenge
  );
  const [isConfirmOpen, setIsConfirm] = useState(false);
  const [ideasSimilares, setIdeasSimilares] = useState<IIdeasSimilares>();

  useEffect(() => {
    const options = {
      applicationId: applicationId,
      culture: props.culture,
      workspaceId: workspaceId,
    };
    
    Promise.all([
      getAllChallengeList(options)
    ]).finally(() => {})

    if (reactNewApp && ideaDetail) {
      const [challenge] = props?.challengeList?.result?.filter(
        (challenge) => challenge?.challengeId === ideaDetail?.challengeId
      );
      const options = {
        ideaId: props?.ideaId,
        challengeId: ideaDetail?.challengeId,
        culture: props?.culture,
        workspaceId: workspaceId,
      };

      setChallenge(challenge);
      getIdeasFormV3(options);
      getIdeaDetail().then(() => {
        setLoad(false);
      });
    } else if (!reactNewApp && ideaDetail) {
      const [challenge] = props?.challengeList?.result?.filter(
        (challenge) => challenge?.challengeId === ideaDetail?.challengeId
      );
      const options = {
        ideaId: props?.ideaId,
        challengeId: ideaDetail?.challengeId,
        culture: props?.culture,
      };

      setChallenge(challenge);
      getIdeasForm(options);
      getIdeaDetail().then(() => {
        setLoad(false);
      });
    }
    getAllUsers({ q: "" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getIdeaDetail = async () => {
    const params = {
      ideaDetailId: props?.ideaId,
    };

    await getAllIdeaDetails(params);
  };

  function handleCancel() {
    setIsConfirm(true);
  }

  function updateForm(formData: FormData) {
    const { putIdeaUpdate } = props;

    formData.append("ideaId", props.ideaId);
    //@ts-ignore
    formData.append("ChallengeId", ideaDetail?.challengeId);
    if (!reactNewApp) {
      formData.append("StateId", Object.keys(ideasForm.initialIdeas)[0]);
    }

    putIdeaUpdate(formData, culture).then(() => {
      history.push(`/idea/details/${props.ideaId}`);
    });
  }

  function getSimilarIdeas(e: any) {
    postIdeasSimilares({
      ...e,
      challengeId: ideaDetail && ideaDetail.challengeId,
      workspaceId,
      applicationId,
      pageNumber: 1,
      pageSize: 6,
    }, culture).then((response) => {
      setIdeasSimilares(response.ideasSimilares);
    });
  }

  return (
    <>
      {!load ? (
        <>
          {reactNewApp ? (
            <IdeaFormV3
              challenge={challenge}
              setChallenge={setChallenge}
              culture={props.culture}
              getIdeasFormV3={getIdeasFormV3}
              handleCancel={handleCancel}
              handleSubmitAction={updateForm}
              ideaFormV3={ideaFormV3}
              mode="edit"
              userList={props.userList}
              ideaDetail={ideaDetail}
              getIdeaSimilar={getSimilarIdeas}
              ideasSimilares={ideasSimilares}
            />
          ) : (
            <IdeaForm
              challenge={challenge}
              setChallenge={setChallenge}
              culture={props.culture}
              getIdeasForm={getIdeasForm}
              handleCancel={handleCancel}
              handleSubmitAction={updateForm}
              ideaForm={ideasForm}
              mode="edit"
              userList={props.userList}
              ideaDetail={ideaDetail}
              getIdeaSimilar={getSimilarIdeas}
              ideasSimilares={ideasSimilares}
            />
          )}
        </>
      ) : (
        <IdeaFormSkeleton />
      )}
      <PopUpConfirmation
        closeButton={() => setIsConfirm(false)}
        sendButton={() => window.history.back()}
        message={<Resource tag="PageEditIdea::ExitWithoutSaving" />}
        isOpen={isConfirmOpen}
        setIsOpen={setIsConfirm}
      />
    </>
  );
}

const mapStateToProps = (store: IAppState, ownProps: any) => {
  const ideaId = ownProps?.match?.params?.ideaId;
  return {
    workspaceId: store.authState.auth.workspaceId,
    ideaFormV3: store.challengeState.ideaFormV3,
    ideasForm: store.challengeState.ideasForm,
    application: store.tenantState.application,
    culture: store.cultureState,
    userList: store.usersState.users,
    challengeList: store.challengeState.challengeList,
    ideaId: ideaId,
    ideaDetail: ideaId ? store.ideasState.ideaDetails : undefined,
    applicationId: store.authState.auth.applicationId,
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>
): IDispatchProps => {
  return {
    getAllUsers: (options: object) => dispatch(getAllUsers(options)),
    getIdeasFormV3: (params: object) => dispatch(getIdeasFormV3(params)),
    getIdeasForm: (parameters: object) => dispatch(getIdeasForm(parameters)),
    putIdeaUpdate: (params: object,culture: ICultureState) => dispatch(putIdeaUpdate(params, culture)),
    getAllIdeaDetails: (params: object) => dispatch(getAllIdeaDetails(params)),
    postIdeasSimilares: (options, culture: ICultureState) => dispatch(postIdeasSimilares(options,culture)),
    getAllChallengeList: (parameters: object) => dispatch(getAllChallengeList(parameters)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditIdea);
